export default class DefaultConfig {
  baseURL = 'https://etherid-api.etheroneafrica.com';

  apiKey = 'e0568e55-f0aa-4aa8-8737-79b1dfa3d4da';

  apiSecret = 'ceef5719-9a83-437c-b8e5-f18bdd15db2e';
}
